import * as Sentry from '@sentry/browser'

const nodeHasLoaded = (domId: string, duration = 500) =>
  new Promise((resolve, reject) => {
    let pollCount = 0
    const interval = window.setInterval(() => {
      pollCount++

      if (document.getElementById(domId)) {
        window.clearInterval(interval)
        return resolve(true)
      }

      if (pollCount > 5) {
        reject(false)
        Sentry.captureException(new Error(`Unable to find dom node by id ${domId}`))
        window.clearInterval(interval)
      }
    }, duration)
  })

export default nodeHasLoaded
